import 'utils/mapUpsertPolyfill';
import PDF_WORKER_SRC from 'utils/pdfWorkerSrc';

let pdfjs;

const getPdfjs = async () => {
  if (pdfjs) {
    return pdfjs;
  }
  await import('react-pdf/dist/Page/TextLayer.css');
  ({ pdfjs } = await import('react-pdf'));
  if (typeof window !== 'undefined' && 'Worker' in window) {
    pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;
  }
  return pdfjs;
};

export default getPdfjs;
